/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Save_ProjectInputs */

const en_shortcut_keys_desc_save_project = /** @type {(inputs: Shortcut_Keys_Desc_Save_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save project or open 'Save As' dialogue box`)
};

const fr_shortcut_keys_desc_save_project = /** @type {(inputs: Shortcut_Keys_Desc_Save_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer le projet ou ouvrir la boite de dialogue 'Enregistrer sous'`)
};

const de_shortcut_keys_desc_save_project = /** @type {(inputs: Shortcut_Keys_Desc_Save_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt speichern oder Dialogfeld „Speichern unter“ öffnen`)
};

const it_shortcut_keys_desc_save_project = /** @type {(inputs: Shortcut_Keys_Desc_Save_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva il progetto o apri la finestra di dialogo "Salva con nome"`)
};

const ru_shortcut_keys_desc_save_project = /** @type {(inputs: Shortcut_Keys_Desc_Save_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохраните проект или откройте диалоговое окно «Сохранить как».`)
};

const es_shortcut_keys_desc_save_project = /** @type {(inputs: Shortcut_Keys_Desc_Save_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar el proyecto o abrir el cuadro de diálogo "Guardar como"`)
};

const zh_cn2_shortcut_keys_desc_save_project = /** @type {(inputs: Shortcut_Keys_Desc_Save_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存项目或打开“另存为”对话框`)
};

const ja_shortcut_keys_desc_save_project = /** @type {(inputs: Shortcut_Keys_Desc_Save_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトを保存するか、「名前を付けて保存」ダイアログボックスを開きます`)
};

const hi_shortcut_keys_desc_save_project = /** @type {(inputs: Shortcut_Keys_Desc_Save_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट सेव करें या 'सेव एज़' डायलॉग बॉक्स खोलें`)
};

const pt_pt2_shortcut_keys_desc_save_project = /** @type {(inputs: Shortcut_Keys_Desc_Save_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salve o projeto ou abra a caixa de diálogo "Salvar como".`)
};

/**
* | output |
* | --- |
* | "Save project or open 'Save As' dialogue box" |
*
* @param {Shortcut_Keys_Desc_Save_ProjectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_save_project = /** @type {((inputs?: Shortcut_Keys_Desc_Save_ProjectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Save_ProjectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_save_project(inputs)
	if (locale === "de") return de_shortcut_keys_desc_save_project(inputs)
	if (locale === "it") return it_shortcut_keys_desc_save_project(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_save_project(inputs)
	if (locale === "es") return es_shortcut_keys_desc_save_project(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_save_project(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_save_project(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_save_project(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_save_project(inputs)
	return en_shortcut_keys_desc_save_project(inputs)
});